import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import EmailPreview from "./emailPreview";
import AlertService from "../../services/AlertService";
const AlertEmailPreview = (props) => {
    // @ts-expect-error - TS7006 - Parameter 'template' implicitly has an 'any' type.
    const loadPreview = (template) => {
        if (props.isStaffInitiatedAlertClosedPreview) {
            return AlertService.getStaffInitiatedAlertClosedTemplatePreview(template).then((response) => response.result);
        }
        return AlertService.getTemplatePreview(template, props.alertTypeId).then((response) => response.result);
    };
    const loadSubject = () => loadPreview(props.getSubject());
    const loadBody = () => loadPreview(props.getBody());
    return (_jsx(EmailPreview, { getBody: loadBody, getSubject: loadSubject, modalId: props.modalId }));
};
export default AlertEmailPreview;
